module.exports = __webpack_public_path__ + "i18n/zh-TW.efc5dc4830c91684f3cabd577c69497a.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1011
// module chunks = 60